import { Injectable } from '@angular/core';
import {Logout} from "@csgofast/auth";
import {Dispatch} from "@ngxs-labs/dispatch-decorator";

@Injectable()
export class BanService {
  @Dispatch() public logout = () => new Logout();
}
